import { API_ROUTES } from '@/const/apiRoutes'
import api from '@/utils/api'
import type { ProfileStatus, ProfileCompletionData, SocialAuthProvider } from '@/types/auth'

const getRedirectUri = (): string => {
  return `${window.location.origin}/auth/callback`
}

export const socialAuthService = {
  initiateGoogleLogin(): void {
    const redirectUri = getRedirectUri()
    window.location.href = `${API_ROUTES.SOCIAL_AUTH_GOOGLE_LOGIN}?redirect_uri=${encodeURIComponent(redirectUri)}`
  },

  initiateLinkedInLogin(): void {
    const redirectUri = getRedirectUri()
    window.location.href = `${API_ROUTES.SOCIAL_AUTH_LINKEDIN_LOGIN}?redirect_uri=${encodeURIComponent(redirectUri)}`
  },

  initiateLogin(provider: SocialAuthProvider): void {
    switch (provider) {
      case 'google': this.initiateGoogleLogin(); break
      case 'linkedin': this.initiateLinkedInLogin(); break
      default: throw new Error(`Unknown social auth provider: ${provider}`)
    }
  },

  async getProfileStatus(): Promise<ProfileStatus> {
    const response = await api.get(API_ROUTES.SOCIAL_AUTH_PROFILE_STATUS)
    return response.data
  },

  async completeProfile(data: ProfileCompletionData): Promise<void> {
    const response = await api.post(API_ROUTES.SOCIAL_AUTH_COMPLETE_PROFILE, data)
    if (response.status >= 400) {
      throw new Error(response.data?.detail || 'Failed to complete profile')
    }
  }
}

export default socialAuthService
